import debounce from 'lodash.debounce';

const DEBOUNCE_DELAY = 200;

const sectionsWithSmallSpacing = [
    'anchor-content-section',
    'text-image'
];

const isSectionWithSmallSpacing = (section: Element): boolean => {
    return sectionsWithSmallSpacing.some(className => {
        return section.classList.contains(className);
    });
};

const resetInitialPaddingBottom = (section: HTMLElement): void => {
    const usingSmallSpacing = isSectionWithSmallSpacing(section);
    if (usingSmallSpacing) {
        section.style.setProperty('padding-bottom', 'var(--section-vertical-padding-sm)');
    } else {
        section.style.setProperty('padding-bottom', 'var(--section-vertical-padding-md)');
    }
};

const calculateMcgLastSectionPadding = (lastSection: HTMLElement, footerAoC: HTMLElement, footerAoCLayout: HTMLElement): void => {
    const isCallToActionSection = lastSection.classList.contains('call-to-action');

    if (isCallToActionSection) {
        return;
    }

    resetInitialPaddingBottom(lastSection);
    const lastSectionStyles = window.getComputedStyle(lastSection);
    const originalPaddingBottom = lastSectionStyles.getPropertyValue('padding-bottom');

    const footerAoCStyles = window.getComputedStyle(footerAoC);
    const footerAoCHeight = footerAoCStyles.getPropertyValue('height') || '0px';

    const AoCLayoutStyles = window.getComputedStyle(footerAoCLayout);
    const AoCLayoutHeight = AoCLayoutStyles.getPropertyValue('height');
    lastSection.style.setProperty('padding-bottom', `calc(${originalPaddingBottom} + ${AoCLayoutHeight} - ${footerAoCHeight} + 64px)`);
};

const mcgFooterInit = (): void => {
    const mcgPage = document.querySelector('body.mcg');
    if (!mcgPage) {
        return;
    }

    const footerAoC = mcgPage.querySelector('.footer-acknowledgement') as HTMLElement;
    if (!footerAoC) {
        return;
    }

    const footerAoCLayout = footerAoC.querySelector('.footer-acknowledgement-layout') as HTMLElement;
    if (!footerAoCLayout) {
        return;
    }

    const pageSections = mcgPage.querySelectorAll('.page-content > section');
    if (!pageSections || pageSections.length === 0) {
        return;
    }

    const lastSection = pageSections[pageSections.length - 1] as HTMLElement;

    // If event-landing-banner is detected, add padding to the last child of all event-listing-group elements instead
    if (lastSection.classList.contains('event-landing-banner')) {
        const eventListingGroups = mcgPage.querySelectorAll('.event-listing-group') as NodeListOf<HTMLElement>;
        eventListingGroups.forEach(eventGroup => {
            const lastChild = eventGroup.lastElementChild as HTMLElement;
            if (lastChild) {
                calculateMcgLastSectionPadding(lastChild, footerAoC, footerAoCLayout);
            }
        });
        return;
    }

    calculateMcgLastSectionPadding(lastSection, footerAoC, footerAoCLayout);

    window.addEventListener('resize', debounce(() => {
        calculateMcgLastSectionPadding(lastSection, footerAoC, footerAoCLayout);
    }, DEBOUNCE_DELAY));
};

const calculateAsmLastSectionPadding = (lastSection: HTMLElement): void => {
    const isCallToActionSection = lastSection.classList.contains('call-to-action');
    const additionalPadding = isCallToActionSection ? '42px' : '40px';

    if (!isCallToActionSection) {
        resetInitialPaddingBottom(lastSection);
    }

    const lastSectionStyles = window.getComputedStyle(lastSection);
    const originalPaddingBottom = lastSectionStyles.getPropertyValue('padding-bottom');
    lastSection.style.setProperty('padding-bottom', `calc(${originalPaddingBottom} + ${additionalPadding})`);
};

const asmFooterInit = (): void => {
    const asmPage = document.querySelector('body.asm');
    if (!asmPage) {
        return;
    }

    const footerAoC = asmPage.querySelector('.footer-acknowledgement');
    if (!footerAoC) {
        return;
    }

    const pageSections = asmPage.querySelectorAll('.page-content > section');
    if (!pageSections || pageSections.length === 0) {
        return;
    }

    const lastSection = pageSections[pageSections.length - 1] as HTMLElement;
    calculateAsmLastSectionPadding(lastSection);

    window.addEventListener('resize', debounce(() => {
        calculateAsmLastSectionPadding(lastSection);
    }, DEBOUNCE_DELAY));
};

const Footer = (): void => {
    mcgFooterInit();
    asmFooterInit();
};

export default Footer;
